/** Scores strictly below this value are flagged as low confidence. */
export const AI_SCORE_LOW_CONFIDENCE_THRESHOLD = 7;

/** Score assigned when no AI score is available (above threshold, so no warning shown). */
export const AI_SCORE_DEFAULT = 7;
